export const AcType = [
  {
    type: "744",
    tailStartRowNumber: 50,
    tailStartRowNumberMargin: 53,
    tailEndRowNumber: 65,
    angel: 4,
    Point1: [560, 605],
    Point2: [517, 1021],
    BizierPoint: [555, 835],
    deckStartRowNumber: 13,
    nose: {
      startRowNumber: 15,
      startRowNumberMargin: 53,
      angel: 40,
      point1: [606, 166],
      point2: [489, 637],
      bizierPoint: [510, 158],
      topDistance: 6
    },
  },
  {
    type: "743",
    tailStartRowNumber: 48,
    tailStartRowNumberMargin: 50,
    tailEndRowNumber: 69,
    angel: 4,
    Point1: [551, 755],
    Point2: [523, 1011],
    BizierPoint: [544, 936],
    deckStartRowNumber: 14,
    nose: {
      startRowNumber: 18,
      startRowNumberMargin: 53,
      angel: 30,
      point1: [597, 117],
      point2: [467, 663],
      bizierPoint: [488, 121],
      topDistance: 8
    },
  },
  {
    type: "346",
    tailStartRowNumber: 50,
    tailStartRowNumberMargin: 58,
    tailEndRowNumber: 61,
    angel: 5,
    Point1: [593, 633],
    Point2: [573, 970],
    BizierPoint: [590, 910],
  },
  {
    type: "343",
    tailStartRowNumber: 38,
    tailStartRowNumberMargin: 40,
    tailEndRowNumber: 46,
    angel: 8,
    Point1: [580, 644],
    Point2: [551, 976],
    BizierPoint: [573, 858],
  },
  {
    type: "a31",
    tailStartRowNumber: 22,
    tailStartRowNumberMargin: 25,
    tailEndRowNumber: 35,
    angel: 4,
    Point1: [593, 611],
    Point2: [568, 971],
    BizierPoint: [581, 865],
  },
  {
    type: "ab6",
    tailStartRowNumber: 34,
    tailStartRowNumberMargin: 38,
    tailEndRowNumber: 45,
    angel: 4,
    Point1: [667, 536],
    Point2: [632, 1040],
    BizierPoint: [651, 872],
  },
  {
    type: "143",
    tailStartRowNumber: 13,
    tailStartRowNumberMargin: 16,
    tailEndRowNumber: 20,
    angel: 6,
    Point1: [593, 611],
    Point2: [568, 971],
    BizierPoint: [581, 865],
  }
];
